// Enum de departamentos
export enum DepartmentType {
  MARKETING = 'MARKETING',
  CREDITO = 'CREDITO'
}

// Enum de categorías
export enum CategoryType {
  IMPRESION = 'IMPRESION',
  REDES_SOCIALES = 'REDES_SOCIALES',
  AUDIO = 'AUDIO',
  VIDEOS = 'VIDEOS',
  GUIA_MARCA = 'GUIA_MARCA',
  IMAGENES = 'IMAGENES'
}

/** Categorías al cargar archivos en descargas: mismo conjunto para marketing y crédito. */
export const DOWNLOAD_UPLOAD_CATEGORY_TYPES: CategoryType[] = [
  CategoryType.AUDIO,
  CategoryType.VIDEOS,
  CategoryType.IMPRESION,
  CategoryType.GUIA_MARCA,
  CategoryType.IMAGENES,
  CategoryType.REDES_SOCIALES
];

// Relación departamento-categoría
export const DEPARTMENT_CATEGORY_RELATION = [
  {
    departmentType: DepartmentType.MARKETING,
    categorieTypes: [...DOWNLOAD_UPLOAD_CATEGORY_TYPES]
  },
  {
    departmentType: DepartmentType.CREDITO,
    categorieTypes: [...DOWNLOAD_UPLOAD_CATEGORY_TYPES]
  }
];

// Nombres normalizados para mostrar en el front
export const DEPARTMENT_LABELS = {
  [DepartmentType.MARKETING]: 'Marketing',
  [DepartmentType.CREDITO]: 'Crédito'
};

export const CATEGORY_LABELS = {
  [CategoryType.IMPRESION]: 'Impresión',
  [CategoryType.REDES_SOCIALES]: 'Redes sociales',
  [CategoryType.AUDIO]: 'Audio',
  [CategoryType.VIDEOS]: 'Videos',
  [CategoryType.GUIA_MARCA]: 'Guía de marca',
  [CategoryType.IMAGENES]: 'Imágenes'
}; 